import React, { useState } from 'react'
import _ from 'lodash'
import { Div, P, Loading } from 'konsys-ui'
import { Query, Mutation } from 'react-apollo'
import detailType from '../util-functions'
import { detailMode } from '../constants'
import { ActionBar, PrintLogList } from '../../../components/truckowner-components'
import { CREATE_TRUCK_OWNER, UPDATE_TRUCK_OWNER } from '../../../constants/graphql/mutation'
import { GET_TRUCK_OWNER_INFO, TRUCK_OWNER_REPORT_LOG_LIST } from '../../../constants/graphql/query'

const Index = ({ props }) => {
  const isNotUpdateMode = props.match.params.mode.toUpperCase() === detailMode.VIEW
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW
  const isUpdateMode = props.match.params.mode.toUpperCase() === detailMode.EDIT
  const [mutationVariables, setMutationVariables] = useState({})
  const [pdfInfo, setPdfInfo] = useState()
  let onChangeHandler = (id, value) => {
    setMutationVariables({
      ...mutationVariables,
      [id]: value,
    })
  }
  return (
    <Div display='flex' flexDirection='column'>
      {/* ================== Data section ================== */}
      {
        isNotUpdateMode || isUpdateMode
          ? <Query
            query={GET_TRUCK_OWNER_INFO}
            variables={{ id: props.match.params.id }}
          >{({ data, error, loading }) => {
            if (loading && _.isEmpty(data)) return <Loading center='true' />
            if (error) return <P>เกิดข้อผิดพลาด</P>
            onChangeHandler = (id, value) => {
              setMutationVariables({
                nameTh: data.TruckownerInfo.nameTh,
                nameEn: data.TruckownerInfo.nameEn,
                type: data.TruckownerInfo.type,
                ...mutationVariables,
                [id]: value,
              })
            }
            if (_.isUndefined(pdfInfo)) setPdfInfo({ nameTh: data.TruckownerInfo.nameTh })
            return detailType(props.match.params, onChangeHandler, mutationVariables, data)
          }}
        </Query>
          : detailType(props.match.params, onChangeHandler, mutationVariables, [])
      }
      {/* ================== Children list section ================== */}
        {
          !isAddMode
          && <Query
            query={TRUCK_OWNER_REPORT_LOG_LIST}
            variables={{
              truckOwnerId: parseInt(props.match.params.id, 10),
              limit: 999,
              orderBy: 'DESC',
              orderField: 'createdAt',
            }}
          >{({ data, error, loading }) => {
            if (loading && _.isEmpty(data)) return <Loading center='true' />
            if (error) return <P>เกิดข้อผิดพลาด</P>
            return <PrintLogList
              data={data}
            />
          }}
        </Query>
        }
      {/* ================== Footer section ================== */}
      {
        !isViewMode
          ? <Mutation
              mutation={isAddMode ? CREATE_TRUCK_OWNER : UPDATE_TRUCK_OWNER}
            >{(doAction, { loading: mutationLoading }) => (
              <ActionBar
                loading={mutationLoading}
                disabled={_.isUndefined(mutationVariables.nameTh) || _.isEmpty(mutationVariables.nameTh)
                  || _.isUndefined(mutationVariables.nameEn) || _.isEmpty(mutationVariables.nameEn)
                  || _.isUndefined(mutationVariables.type)}
                isAddMode={isAddMode}
                isViewMode={isViewMode}
                doAction={doAction}
                mutationVariables={{
                  ...mutationVariables,
                  ...!isAddMode ? {
                    id: Number(props.match.params.id),
                  } : {},
                }}
                props={props}
                pdfInfo={pdfInfo}
              />
            )}
            </Mutation>
          : <ActionBar
              isAddMode={isAddMode}
              isViewMode={isViewMode}
              props={props}
              pdfInfo={pdfInfo}
            />
      }
    </Div>
  )
}

export default Index
export { Index }
